import * as React from 'react'
import { useState } from 'react';
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Dropdown, DropdownDivider, Navbar } from 'flowbite-react';
import Menu from './menu.tsx';

function Nav() {
  const location = useLocation();
  const defaultLogo = "images/logo.webp";
  const oracleAlgo = "images/oracle-algo.svg";
  const logo = location.pathname === "/oraclealgo" ? oracleAlgo : defaultLogo;

  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  // state to apply navbar bg on scroll
  const [scrolling, setScrolling] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  
  return (
    <Navbar className={`nav bg-transparent mt-4 fixed z-[1000] backdrop-filter backdrop-blur-1200 m-0 w-full max-md:flex-row ${scrolling ? "bg-black shadow-lg" : "bg-transparent"}`}>
      <Navbar.Brand className='max-md:w-[150px] mt-1' href="https://unityacademy.io">
        <img src={logo} className="mr-3 h-12" alt="Flowbite React Logo" />
      </Navbar.Brand>
      
      <Menu isOpen={isMenuOpen} onClose={handleMenuClose} />
      <Navbar.Toggle className='focus:bg-transparent max-md:hidden focus:border-0 bg-none hover:bg-none hover:border-0 focus:ring-0 pr-0' />
      <Navbar.Collapse className='duration-1000 mr-5 '>
        <Navbar.Link className='hover:bg-transparent flex items-center h-full text-white font-semibold text-base' href="https://unityacademy.io">Home</Navbar.Link>

        <Navbar.Link className='hover:bg-transparent flex items-center h-full text-white font-semibold text-base' href="https://unityacademy.io#pricing">Pricing</Navbar.Link>
        
        <Navbar.Link className='hover:bg-transparent flex items-center h-full text-white font-semibold text-base' href="https://app.unityacademy.io/dashboard">Education</Navbar.Link>

        <Navbar.Link className='hover:bg-transparent flex items-center h-full text-white font-semibold text-base' href="/oraclealgo">OracleAlgo</Navbar.Link>

      </Navbar.Collapse>
    </Navbar>
  );
}

export default Nav;